"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nestedMenuItemsFromObject = void 0;
var react_1 = __importDefault(require("react"));
var NestedMenuItem_1 = require("./NestedMenuItem");
var IconMenuItem_1 = require("./IconMenuItem");
/**
 * Create a JSX element with nested elements creating a nested menu.
 * Every menu item should have a uid provided
 */
function nestedMenuItemsFromObject(_a) {
    var items = _a.menuItemsData, isOpen = _a.isOpen, handleClose = _a.handleClose;
    return items.map(function (item) {
        var leftIcon = item.leftIcon, rightIcon = item.rightIcon, label = item.label, items = item.items, callback = item.callback;
        if (items && items.length > 0) {
            // Recurse deeper
            return (react_1.default.createElement(NestedMenuItem_1.NestedMenuItem, { key: label, leftIcon: leftIcon, rightIcon: rightIcon, label: label, parentMenuOpen: isOpen }, nestedMenuItemsFromObject({
                menuItemsData: items,
                isOpen: isOpen,
                handleClose: handleClose,
            })));
        }
        else {
            // No children elements, return MenuItem
            return (react_1.default.createElement(IconMenuItem_1.IconMenuItem, { key: label, leftIcon: leftIcon, rightIcon: rightIcon, label: label, onClick: function () {
                    handleClose();
                    callback();
                } }));
        }
    });
}
exports.nestedMenuItemsFromObject = nestedMenuItemsFromObject;
